module.exports = __webpack_public_path__ + "static/media/sorteio_active.111509ca.svg";